<template>
  <v-data-table
    :headers="headers"
    :items="data"
    hide-default-footer
    disable-pagination
  >
    <template v-slot:[`item.title`]="{ item }">
      <router-link to="/data/view">{{ item.title }}</router-link>
    </template>
    <!-- <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="onEdit(item)">mdi-pencil</v-icon>
      <v-icon small @click="onRemove(item)">mdi-delete</v-icon>
    </template> -->
  </v-data-table>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: "No",
          value: "num",
          width: "10%",
        },
        {
          text: "제목",
          value: "title",
          width: "60%",
        },
        {
          text: "등록일",
          value: "date",
          width: "15%",
          sortable: false,
        },
        {
          text: "작성자",
          value: "author",
          width: "15%",
          sortable: false,
        },
        // {
        //   text: "",
        //   value: "actions",
        //   width: "10%",
        //   align: "center",
        //   sortable: false,
        // },
      ],
      data: [
        { num: "1", title: "인사조직도", author: "관리자", date: "2020-04-05" },
      ],
    };
  },
  // props: ["projects"],
  methods: {
    onEdit(item) {
      this.$emit("onEditClick", item);
    },
    onRemove(item) {
      this.$emit("removeProject", item);
    },
  },
};
</script>

<style></style>
